<template>
    <div class="search-filter" ref="searchFilter">
        <div class="search-filter__content">
            <form class="search-filter__form" @submit.prevent="search">
                <div class="search-filter__title">
                    {{ $t(`searchCustomerFields.searchTitle`) }}
                </div>

                <div class="search-filter__row">
                    <div class="search-filter__column">
                        <MultiSelectDropdown v-if="isScopedCollectionFilter"
                            :items="teamSelectionOptions"
                            :placeholder="$t('settingsPage.selectTeamPlaceholder')" label="name"
                            :reduce="(team) => team.id" :selected="userTeamInput" class="team-select"
                            @input="getFiltersData" />
                        <MultiSelectDropdown v-else
                            :items="teamSelectionOptions"
                            :placeholder="$t('settingsPage.selectTeamPlaceholder')" label="name"
                            :reduce="(team) => team.id" :selected="userTeamInput"
                            class="select select--default select-column" @input="getFiltersData" />
                    </div>

                    <div class="search-filter__column" v-if="searchType === 'user'">
                        <VSelect :options="userStatus" :reduce="(status) => status.value" placeholder="Status"
                            label="name" v-model="selectedStatus" class="select select--default select-column" />
                    </div>

                    <div class="search-filter__column" v-if="searchType !== 'user'"></div>
                    <div class="search-filter__column" v-if="searchType !== 'user'"></div>
                </div>

                <Loading v-if="loadingResources" />

                <div v-else>
                    <template v-if="searchType === 'lead'">
                        <div class="search-filter__row">
                            <div class="search-filter__column">
                                <label class="date-label label-block">{{ $t('searchLeads.leadStatus') }}</label>
                                <input v-if="isTeamSelectionRequired" disabled
                                    :placeholder="$t('searchLeads.leadStatus')"
                                    class="multi__placeholder input input--default input--shadow style-full" />
                                <MultiSelectDropdown v-else :items="resource.customer_sub_statuses || []"
                                    :placeholder="$t('searchLeads.leadStatus')" label="name"
                                    @input="leadStatuses = $event" :reduce="(s) => s.id" :selected="leadStatuses" />
                            </div>

                            <div class="search-filter__column">
                                <label class="date-label label-block">{{ $t('searchLeads.leadCategory') }}</label>
                                <input v-if="isTeamSelectionRequired || !resource.branchCategories?.length" disabled
                                    :placeholder="$t('searchLeads.leadCategory')"
                                    class="multi__placeholder input input--default input--shadow style-full" />
                                <MultiSelectDropdown v-else :items="resource.branchCategories || []"
                                    :placeholder="$t('searchLeads.leadCategory')" :label="`name`"
                                    @input="leadCategories = $event" :reduce="(c) => c.id" :selected="leadCategories" />
                            </div>

                            <div class="search-filter__column"
                                v-if="searchType !== 'potentialCustomer' && searchType !== 'lead'">
                                <input disabled v-if="userTeamLength > 1 && userTeamInput.length == 0"
                                    :placeholder="$t('searchCustomerFields.companyTitle')" style="width: 100%;"
                                    class="multi__placeholder input input--default input--shadow" />

                                <MultiSelectDropdown v-else :items="resource.companies"
                                    :placeholder="$t('searchCustomerFields.companyTitle')" label="name"
                                    @input="companies = $event" :reduce="(company) => company.id"
                                    :selected="companies" />
                            </div>

                            <div class="search-filter__column" v-if="searchType == 'lead'">
                                <label class="date-label label-block">{{ $t('searchLeads.leadReferral') }}</label>
                                <input disabled
                                    v-if="(userTeamLength > 1 && userTeamInput.length == 0) || (!resource.referrals || resource.referrals.length === 0)"
                                    :placeholder="$t('searchLeads.leadReferral')" style="width: 100%;"
                                    class="multi__placeholder input input--default input--shadow" />

                                <MultiSelectDropdown v-else :items="resource.referrals || []"
                                    :placeholder="$t('searchLeads.leadReferral')" label="name"
                                    @input="leadReferrals = $event" :reduce="(referral) => referral.id"
                                    :selected="leadReferrals" />
                            </div>
                        </div>

                        <div class="search-filter__row" v-if="searchType == 'lead'">
                            <div class="search-filter__column">
                                <label class="date-label label-block">{{ $t('searchCustomerFields.agentTitle')
                                    }}</label>
                                <input v-if="isTeamSelectionRequired" disabled
                                    :placeholder="$t('searchCustomerFields.agentTitle')"
                                    class="multi__placeholder input input--default input--shadow style-full" />
                                <MultiSelectDropdown v-else :items="resource.agents || []"
                                    :placeholder="$t('searchCustomerFields.agentTitle')" @input="agents = $event"
                                    :customLabel="(a) => `${a.first_name} ${a.last_name}`" :reduce="(a) => a.id"
                                    :selected="agents" />
                            </div>

                            <div class="search-filter__column search-filter__column--inputs">
                                <div class="form__field style-full">
                                    <label class="date-label label-block">{{ $t('searchCustomerFields.zip') }}</label>
                                    <div class="report__choose-details-datepickers">
                                        <input v-if="isTeamSelectionRequired" type="text"
                                            class="input input--default disabled-input"
                                            :placeholder="$t(`searchCustomerFields.${'from'}`)" disabled />
                                        <input v-else type="text" class="input input--default"
                                            :placeholder="$t(`searchCustomerFields.${'from'}`)" v-model="zipFrom" />
                                        <div class="input input--default report__choose-details-seperator">-</div>
                                        <input v-if="isTeamSelectionRequired" type="text"
                                            class="input input--default disabled-input"
                                            :placeholder="$t(`searchCustomerFields.${'to'}`)" disabled />
                                        <input v-else type="text" class="input input--default"
                                            :placeholder="$t(`searchCustomerFields.${'to'}`)" v-model="zipTo" />
                                    </div>
                                </div>
                            </div>

                            <div class="search-filter__column search-filter__column--inputs">
                                <div class="form__field style-full deadline">
                                    <label class="date-label label-block">{{ $t('searchLeads.deadline') }}</label>
                                    <div class="report__choose-details-datepickers">
                                        <Datepicker v-if="isTeamSelectionRequired"
                                            class="input input--default disabled-input"
                                            :placeholder="$t(`searchCustomerFields.${'from'}`)" disabled />
                                        <Datepicker v-else class="input input--default"
                                            :config="statics.datePickerConfig"
                                            :placeholder="$t(`searchCustomerFields.${'from'}`)"
                                            v-model="deadlineFrom" />
                                        <div class="input input--default report__choose-details-seperator">-</div>
                                        <Datepicker v-if="isTeamSelectionRequired"
                                            class="input input--default disabled-input"
                                            :placeholder="$t(`searchCustomerFields.${'to'}`)" disabled />
                                        <Datepicker v-else class="input input--default"
                                            :config="statics.datePickerConfig"
                                            :placeholder="$t(`searchCustomerFields.${'to'}`)" v-model="deadlineTo" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-else-if="searchType !== 'user'">
                        <div class="search-filter__row">
                            <div class="search-filter__column" v-if="searchType !== 'policy'">
                                <label class="date-label label-block">{{ $t('searchCustomerFields.companyType')
                                    }}</label>
                                <input v-if="isTeamSelectionRequired" disabled
                                    :placeholder="$t('searchCustomerFields.companyType')"
                                    class="multi__placeholder input input--default input--shadow style-full" />
                                <MultiSelectDropdown v-else :items="resource.companyTypes"
                                    :placeholder="$t('searchCustomerFields.companyType')" label="type"
                                    @input="companyTypes = $event" :reduce="(t) => t.id" :selected="companyTypes" />
                            </div>

                            <div class="search-filter__column" v-if="searchType !== 'potentialCustomer'">
                                <label class="date-label label-block">{{ $t('searchCustomerFields.companyTitle')
                                    }}</label>
                                <input v-if="isTeamSelectionRequired" disabled
                                    :placeholder="$t('searchCustomerFields.companyTitle')"
                                    class="multi__placeholder input input--default input--shadow style-full" />
                                <MultiSelectDropdown v-else :items="resource.companies"
                                    :placeholder="$t('searchCustomerFields.companyTitle')" label="name"
                                    @input="companies = $event" :reduce="(c) => c.id" :selected="companies" />
                            </div>

                            <div class="search-filter__column" v-if="searchType === 'potentialCustomer'">
                                <label class="date-label label-block">{{ $t('searchLeads.leadCategory') }}</label>
                                <input v-if="isTeamSelectionRequired" disabled
                                    :placeholder="$t('searchLeads.leadCategory')"
                                    class="multi__placeholder input input--default input--shadow style-full" />
                                <MultiSelectDropdown v-else :items="resource.branchCategories || []"
                                    :placeholder="$t('searchLeads.leadCategory')" :label="`name`"
                                    @input="branchCategories = $event" :reduce="(c) => c.id"
                                    :selected="branchCategories" />
                            </div>
                            <div class="search-filter__column" v-if="searchType === 'policy'"></div>
                        </div>

                        <div class="search-filter__row">
                            <div class="search-filter__column" v-if="searchType !== 'potentialCustomer'">
                                <label class="date-label label-block">{{ $t('searchCustomerFields.status') }}</label>
                                <input v-if="isTeamSelectionRequired" disabled placeholder="Status"
                                    class="multi__placeholder input input--default input--shadow style-full" />
                                <MultiSelectDropdown v-else :items="resource.policyStatuses" placeholder="Status"
                                    label="name" @input="policyStatuses = $event" :reduce="(s) => s.id"
                                    :selected="policyStatuses" />
                            </div>

                            <div class="search-filter__column">
                                <label class="date-label label-block">{{ $t('searchCustomerFields.agentTitle')
                                    }}</label>
                                <input v-if="isTeamSelectionRequired" disabled
                                    :placeholder="$t('searchCustomerFields.agentTitle')"
                                    class="multi__placeholder input input--default input--shadow style-full" />
                                <MultiSelectDropdown v-else :items="resource.agents || []"
                                    :placeholder="$t('searchCustomerFields.agentTitle')" @input="agents = $event"
                                    :customLabel="(a) => `${a.first_name} ${a.last_name}`" :reduce="(a) => a.id"
                                    :selected="agents" />
                            </div>

                            <div class="search-filter__column" v-if="searchType === 'potentialCustomer'">
                                <label class="date-label label-block">{{ $t('searchCustomerFields.priorities')
                                    }}</label>
                                <input v-if="isTeamSelectionRequired" disabled
                                    :placeholder="$t('searchCustomerFields.priorities')"
                                    class="multi__placeholder input input--default input--shadow style-full" />
                                <MultiSelectDropdown v-else :items="resource.priorities"
                                    :placeholder="$t('searchCustomerFields.priorities')" @input="priorities = $event"
                                    label="type" :reduce="(p) => p.id" :selected="priorities" />
                            </div>

                            <div class="search-filter__column" v-if="searchType === 'customer'">
                                <label class="date-label label-block">{{ $t('searchCustomerFields.terminations')
                                    }}</label>
                                <input v-if="isTeamSelectionRequired" disabled
                                    :placeholder="$t('searchCustomerFields.terminations')"
                                    class="multi__placeholder input input--default input--shadow style-full" />
                                <VSelect v-else :options="terminationsArr" :reduce="(t) => t.value"
                                    :placeholder="$t('searchCustomerFields.terminations')" label="name"
                                    v-model="selectedTermination" class="select select--default select-column" />
                            </div>
                        </div>

                        <div class="divider">
                            <div class="line-divider"></div>
                            <div class="text-divider" @click="moreFilters = !moreFilters">
                                <p v-if="moreFilters">{{ $t('searchCustomerFields.lessFilters') }}</p>
                                <p v-else>{{ $t('searchCustomerFields.moreFilters') }}</p>
                                <img src="../assets/icons/default/Bold 2px-chevron_down.svg" :style="textDividerStyle"
                                    alt="chevron">
                            </div>
                        </div>

                        <transition name="slide-fade-in">
                            <div v-if="moreFilters">
                                <div class="search-filter__row">
                                    <!-- <div class="search-filter__column search-filter__column--inputs" v-if="searchType === 'customer'">
                                        <div class="form__field style-full" v-if="canAccessPaymentFilter">
                                            <label class="date-label label-block">{{ $t('searchCustomerFields.paymentTitle') }}</label>
                                            <input v-if="isTeamSelectionRequired" disabled :placeholder="$t('searchCustomerFields.paymentTitle')" class="multi__placeholder input input--default input--shadow style-full" />
                                            <v-select v-else :options="paymentStatusArr" :reduce="(s) => s.value" :placeholder="$t('searchCustomerFields.paymentTitle')" label="name" v-model="paymentStatus" class="select select--default select-column payment-type">
                                                <template #option="option">
                                                    <div class="custom-option">
                                                        <div class="icon custom-option-icon" :class="option.icon"></div>
                                                        <div class="option-name">{{ option.name }}</div>
                                                    </div>
                                                </template>
</v-select>
</div>
</div> -->


                                    <div class="search-filter__column search-filter__column--inputs"
                                        v-if="searchType === 'customer'">
                                        <div class="form__field style-full" v-if="canAccessPaymentFilter">
                                            <label class="date-label label-block">{{
                                                $t('searchCustomerFields.paymentTitle') }}</label>
                                            <input v-if="isTeamSelectionRequired" disabled
                                                :placeholder="$t('searchCustomerFields.paymentTitle')"
                                                class="multi__placeholder input input--default input--shadow style-full" />
                                            <v-select v-else :options="paymentStatusArr"
                                                :reduce="(s) => s?.value ?? null"
                                                :placeholder="$t('searchCustomerFields.paymentTitle')"
                                                :getOptionLabel="(option) => typeof option === 'object' && option !== null ? (option.name || option.label || '') : (option || '')"
                                                :getOptionValue="(option) => typeof option === 'object' && option !== null ? (option.value ?? null) : option"
                                                v-model="paymentStatus"
                                                class="select select--default select-column payment-type">
                                                <template #option="option">
                                                    <div class="custom-option">
                                                        <div class="icon custom-option-icon" :class="option?.icon">
                                                        </div>
                                                        <div class="option-name">{{ option?.name || option?.label || ''
                                                            }}</div>
                                                    </div>
                                                </template>
                                            </v-select>
                                        </div>
                                    </div>

                                    <div class="search-filter__column search-filter__column--inputs"
                                        :class="{ 'search-filter__column--half': searchType === 'potentialCustomer' }">
                                        <div class="form__field style-full">
                                            <label class="date-label label-block">{{
                                                $t('searchCustomerFields.policyStartDate') }}</label>
                                            <div class="report__choose-details-datepickers">
                                                <Datepicker v-if="isTeamSelectionRequired"
                                                    class="input input--default disabled-input"
                                                    :placeholder="$t(`searchCustomerFields.${'from'}`)" disabled />
                                                <Datepicker v-else class="input input--default"
                                                    :config="statics.datePickerConfig"
                                                    :placeholder="$t(`searchCustomerFields.${'from'}`)"
                                                    v-model="startDateFrom" />
                                                <div class="input input--default report__choose-details-seperator">-
                                                </div>
                                                <Datepicker v-if="isTeamSelectionRequired"
                                                    class="input input--default disabled-input"
                                                    :placeholder="$t(`searchCustomerFields.${'to'}`)" disabled />
                                                <Datepicker v-else class="input input--default"
                                                    :config="statics.datePickerConfig"
                                                    :placeholder="$t(`searchCustomerFields.${'to'}`)"
                                                    v-model="startDateTo" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="search-filter__column search-filter__column--inputs"
                                        v-if="searchType !== 'potentialCustomer'">
                                        <div class="form__field style-full">
                                            <label class="date-label label-block">{{
                                                $t('searchCustomerFields.policySubmitDate') }}</label>
                                            <div class="report__choose-details-datepickers">
                                                <Datepicker v-if="isTeamSelectionRequired"
                                                    class="input input--default disabled-input"
                                                    :placeholder="$t(`searchCustomerFields.${'from'}`)" disabled />
                                                <Datepicker v-else class="input input--default"
                                                    :config="statics.datePickerConfig"
                                                    :placeholder="$t(`searchCustomerFields.${'from'}`)"
                                                    v-model="submitDateFrom" />
                                                <div class="input input--default report__choose-details-seperator">-
                                                </div>
                                                <Datepicker v-if="isTeamSelectionRequired"
                                                    class="input input--default disabled-input"
                                                    :placeholder="$t(`searchCustomerFields.${'to'}`)" disabled />
                                                <Datepicker v-else class="input input--default"
                                                    :config="statics.datePickerConfig"
                                                    :placeholder="$t(`searchCustomerFields.${'to'}`)"
                                                    v-model="submitDateTo" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="search-filter__row">
                                    <div class="search-filter__column search-filter__column--inputs"
                                        v-if="searchType === 'customer'">
                                        <div class="filter-birthday style-full">
                                            <label class="date-label label-block">{{ $t('searchCustomerFields.birthday')
                                                }}</label>
                                            <div class="report__choose-details-datepickers">
                                                <Datepicker v-if="isTeamSelectionRequired"
                                                    class="input input--default disabled-input"
                                                    :placeholder="$t(`searchCustomerFields.${'from'}`)" disabled />
                                                <Datepicker v-else class="input input--default birthday"
                                                    :config="statics.datePickerConfig"
                                                    :placeholder="$t(`searchCustomerFields.${'from'}`)"
                                                    v-model="birthdayFrom" />
                                                <div class="input input--default report__choose-details-seperator">-
                                                </div>
                                                <Datepicker v-if="isTeamSelectionRequired"
                                                    class="input input--default disabled-input"
                                                    :placeholder="$t(`searchCustomerFields.${'to'}`)" disabled />
                                                <Datepicker v-else class="input input--default birthday"
                                                    :config="statics.datePickerConfig"
                                                    :placeholder="$t(`searchCustomerFields.${'to'}`)"
                                                    v-model="birthdayTo" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="search-filter__column search-filter__column--inputs"
                                        v-if="searchType === 'customer' || searchType === 'potentialCustomer'">
                                        <div class="form__field style-full">
                                            <label class="date-label label-block">{{ $t('searchCustomerFields.zip')
                                                }}</label>
                                            <div class="report__choose-details-datepickers">
                                                <input v-if="isTeamSelectionRequired" type="text"
                                                    class="input input--default disabled-input"
                                                    :placeholder="$t(`searchCustomerFields.${'from'}`)" disabled />
                                                <input v-else type="text" class="input input--default"
                                                    :placeholder="$t(`searchCustomerFields.${'from'}`)"
                                                    v-model="zipFrom" />
                                                <div class="input input--default report__choose-details-seperator">-
                                                </div>
                                                <input v-if="isTeamSelectionRequired" type="text"
                                                    class="input input--default disabled-input"
                                                    :placeholder="$t(`searchCustomerFields.${'to'}`)" disabled />
                                                <input v-else type="text" class="input input--default"
                                                    :placeholder="$t(`searchCustomerFields.${'to'}`)" v-model="zipTo" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="search-filter__column search-filter__column--inputs">
                                        <div class="form__field style-full">
                                            <label class="date-label label-block">{{
                                                $t('searchCustomerFields.policyEndDate') }}</label>
                                            <div class="report__choose-details-datepickers">
                                                <Datepicker v-if="isTeamSelectionRequired"
                                                    class="input input--default disabled-input"
                                                    :placeholder="$t(`searchCustomerFields.${'from'}`)" disabled />
                                                <Datepicker v-else class="input input--default"
                                                    :config="statics.datePickerConfig"
                                                    :placeholder="$t(`searchCustomerFields.${'from'}`)"
                                                    v-model="endDateFrom" />
                                                <div class="input input--default report__choose-details-seperator">-
                                                </div>
                                                <Datepicker v-if="isTeamSelectionRequired"
                                                    class="input input--default disabled-input"
                                                    :placeholder="$t(`searchCustomerFields.${'to'}`)" disabled />
                                                <Datepicker v-else class="input input--default"
                                                    :config="statics.datePickerConfig"
                                                    :placeholder="$t(`searchCustomerFields.${'to'}`)"
                                                    v-model="endDateTo" />
                                            </div>
                                        </div>
                                    </div>

                                    <div class="search-filter__column" v-if="searchType === 'policy'"></div>
                                </div>

                                <div class="search-filter__row" v-if="searchType === 'customer'">
                                    <div class="search-filter__column style-full">
                                        <label class="date-label label-block">{{ $t('pendenciesTable.pendencyNr')
                                            }}</label>
                                        <input v-if="isTeamSelectionRequired" type="text"
                                            class="input input--default disabled-input"
                                            :placeholder="$t('pendenciesTable.pendencyNr')" disabled />
                                        <input v-else type="text" class="input input--default"
                                            :placeholder="$t('pendenciesTable.pendencyNr')" v-model="pendencyNr" />
                                    </div>
                                    <div class="search-filter__column style-full">
                                        <label class="date-label label-block">{{ $t('addMandateModal.mandatesFilter')
                                            }}</label>
                                        <input v-if="isTeamSelectionRequired" type="text"
                                            class="input input--default disabled-input"
                                            :placeholder="$t('addMandateModal.mandatesFilter')" disabled /> 
                                        <VSelect class="select select--default select-column" v-else
                                            :options="resource.mandateStatuses" :reduce="(s) => s.id"
                                            :placeholder="$t('addMandateModal.mandatesFilter')" label="name"
                                            v-model="selectedMandateStatus" />
                                    </div>
                                    <div class="search-filter__column"></div>
                                </div>
                            </div>
                        </transition>
                    </template>

                    <div class="search-filter__row search-filter__action-row">
                        <div class="search-filter__column search-filter__export-column">
                            <a v-if="searchType === 'customer' && canExportCustomer"
                                class="search-export__button button button--default" v-show="!isRequesting"
                                @click="exportCustomersTable">
                                Export <img src="../assets/icons/default/export_files_icon.svg" alt="export">
                            </a>
                            <a v-else-if="searchType === 'policy' && canExportScopedCollection('policy_export')"
                                class="search-export__button button button--default" v-show="!isRequesting"
                                @click="exportPoliciesTable">
                                Export <img src="../assets/icons/default/export_files_icon.svg" alt="export">
                            </a>
                            <a v-else-if="searchType === 'user' && canExportScopedCollection('view_all_users')"
                                class="search-export__button button button--default" v-show="!isRequesting"
                                @click="exportUsersTable">
                                Export <img src="../assets/icons/default/export_files_icon.svg" alt="export">
                            </a>
                            <a v-else-if="searchType === 'lead' && canExportScopedCollection('customer_export')"
                                class="search-export__button button button--default" v-show="!isRequesting"
                                @click="exportLeadsTable">
                                Export <img src="../assets/icons/default/export_files_icon.svg" alt="export">
                            </a>
                        </div>

                        <div class="search-filter__column search-filter__filter-column">
                            <div v-show="isRequesting"
                                class="search-filter__button button button--default button--loading"></div>
                            <button v-show="!isRequesting && canApplyFilters" type="button" @click="search"
                                class="search-filter__button button button--default">
                                {{ $t('searchCustomerFields.applyBtn') }}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Loading from "@/partials/Loading";
import MultiSelectDropdown from "@/partials/MultiSelectDropdown";
import statics from "@/statics";
//import withPopper from "@/helpers/withPopper";

// Props Configuration definitions
const props = defineProps({
    toggleSearchFilter: {
        required: true,
        type: Function,
    },
    filterToggler: {
        required: true,
        type: null,
    },
    searchType: {
        required: true,
        type: String,
    },
});

// Services Initialization 
const route = useRoute();
const router = useRouter();
const store = useStore();

// View Container Elements references 
const searchFilter = ref(null);

// Form Reactive Context Hooks
const loadingResources = ref(false);
const userTeamInput = ref([]);
const selectedTeam = ref(null);
const moreFilters = ref(false);
const isRequesting = ref(false);

const birthdayFrom = ref("");
const birthdayTo = ref("");
const zipFrom = ref("");
const zipTo = ref("");
const agents = ref([]);
const companyTypes = ref([]);
const companies = ref([]);
const branchCategories = ref([]);
const policyStatuses = ref([]);
const priorities = ref([]);
const leadStatuses = ref([]);
const leadCategories = ref([]);
const leadReferrals = ref([]);
const deadlineFrom = ref("");
const deadlineTo = ref("");
const searchKeywords = ref("");
const resource = ref({});

const selectedTermination = ref("");
const selectedMandateStatus = ref("");
const selectedStatus = ref(null);
const normalizeUserStatus = (value) => {
    if (value === null || value === undefined || value === "") return null;
    const normalized = Number(value);
    return Number.isInteger(normalized) ? normalized : null;
};
const normalizeMandateStatusList = (value) => {
    if (value === null || value === undefined || value === "") return undefined;
    const values = Array.isArray(value) ? value : [value];
    const normalized = values
        .map((item) => (item === null || item === undefined || item === "" ? null : item))
        .filter((item) => item !== null && item !== undefined && item !== "");
    return normalized.length ? normalized : undefined;
};
const startDateFrom = ref("");
const startDateTo = ref("");
const endDateFrom = ref("");
const endDateTo = ref("");
const pendencyNr = ref("");
const submitDateFrom = ref("");
const submitDateTo = ref("");
const paymentStatus = ref("");

// Component Collections Constants
const terminationsArr = [
    { id: 1, value: "true", name: "Ja" },
    { id: 2, value: "false", name: "Nien" },
];

const userStatus = [
    { id: 1, value: null, name: "All" },
    { id: 2, value: "1", name: "Active" },
    { id: 3, value: "0", name: "Inactive" },
];

const paymentStatusArr = [
    { id: 1, value: "unpaid", name: "Unbezahlt", icon: "icon__payment" },
    { id: 2, value: "pending", name: "Zahlung hinzugefügt (ausstehend)", icon: "icon__payment--pending" },
    { id: 3, value: "paid", name: "Bezahlt", icon: "icon__payment--paid" },
];

// Computed State Context Mapping
const searchCustomerForms = computed(() => store.getters.searchCustomerForms);
const searchPotentialCustomerForms = computed(() => store.getters.searchPotentialCustomerForms);
const searchLeadForms = computed(() => store.getters.searchLeadForms);

const searchPoliciesForms = computed(() => store.getters.searchPoliciesForms);
const loggedUser = computed(() => store.getters.loggedUser);
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);

const terminationValue = computed(() => {
    if (selectedTermination.value === "true") return true;
    if (selectedTermination.value === "false") return false;
    return "";
});

const textDividerStyle = computed(() => ({
    transform: moreFilters.value ? "scaleY(-1)" : "scaleY(1)",
    transition: "transform 0.3s ease",
}));

const userTeams = computed(() => loggedUser.value?.teams || []);
const teamSelectionOptions = computed(() => {
    if (isSuperAdmin.value) return store.getters.teams || [];
    return userTeams.value;
});
const userTeamLength = computed(() => loggedUser.value?.teams?.length || 0);
const isScopedCollectionFilter = computed(() => ["customer", "potentialCustomer", "policy", "lead", "user"].includes(props.searchType));
const customerSelectedTeamId = computed(() => userTeamInput.value[0] ?? null);
const isTeamSelectionRequired = computed(() =>
    isScopedCollectionFilter.value
        ? userTeamInput.value.length === 0
        : userTeamLength.value > 1 && userTeamInput.value.length === 0
);
const canApplyFilters = computed(() => isScopedCollectionFilter.value || userTeamInput.value.length > 0);
const canExportCustomer = computed(() => {
    const teamId = customerSelectedTeamId.value;
    return teamId !== null && store.getters.hasTeamPermission("customer_export", teamId);
});
const canAccessPaymentFilter = computed(() => {
    const teamId = customerSelectedTeamId.value;
    if (teamId !== null) {
        return store.getters.hasTeamPermission("policy_service_payment_access", teamId);
    }
    const teamIds = store.getters.authorizedTeamIds("policy_service_payment_access");
    return teamIds === null || teamIds.length > 0;
});
const canExportScopedCollection = (ability) => {
    const teamId = customerSelectedTeamId.value;
    return teamId !== null && store.getters.hasTeamPermission(ability, teamId);
};

// Component Data Initialization Hydration Context Hook
onMounted(async () => {
    if (isScopedCollectionFilter.value && isSuperAdmin.value && !store.getters.teams.length) {
        await store.dispatch("getTeams");
    }
    if (route.name === "PotentialCustomers") resource.value = searchPotentialCustomerForms.value;
    else if (route.name === "Policies") resource.value = searchPoliciesForms.value;
    else if (route.name === "Leads") resource.value = searchLeadForms.value;
    else resource.value = searchCustomerForms.value;

    const q = route.query;
    searchKeywords.value = q.search || "";
    agents.value = q.agents ? q.agents.split(",") : [];
    companyTypes.value = q.companyTypes ? q.companyTypes.split(",") : [];
    companies.value = q.companies && ["Customers", "Policies"].includes(route.name) ? q.companies.split(",") : [];
    branchCategories.value = q.branchCategories ? q.branchCategories.split(",") : [];
    policyStatuses.value = q.policyStatuses && ["Customers", "Policies", ""].includes(route.name) ? q.policyStatuses.split(",") : [];
    priorities.value = q.priorities && route.name === "PotentialCustomers" ? q.priorities.split(",") : [];

    leadStatuses.value = q.lead_statuses && route.name === "Leads" ? q.lead_statuses.split(",").map(Number) : [];
    leadCategories.value = q.lead_categories && route.name === "Leads" ? q.lead_categories.split(",").map(Number) : [];
    leadReferrals.value = q.lead_referrals && route.name === "Leads" ? q.lead_referrals.split(",").map(Number) : [];

    deadlineFrom.value = q.deadline_from || "";
    deadlineTo.value = q.deadline_to || "";
    birthdayFrom.value = q.birthday_from || q.birthdayFrom || q.birthday || "";
    birthdayTo.value = q.birthday_to || q.birthdayTo || q.birthday || "";
    zipFrom.value = q.zip_from || "";
    zipTo.value = q.zip_to || "";
    startDateFrom.value = q.startDateFrom || "";
    startDateTo.value = q.startDateTo || "";
    endDateFrom.value = q.endDateFrom || "";
    endDateTo.value = q.endDateTo || "";
    submitDateFrom.value = q.submitDateFrom || "";
    submitDateTo.value = q.submitDateTo || "";
    selectedTermination.value = q.has_terminations || "";
    paymentStatus.value = q.payment_status || "";
    pendencyNr.value = ["Customers", "Dashboard", "AccountDetails"].includes(route.name) ? (q.pendency_number || "") : "";

    if (isScopedCollectionFilter.value) {
        if (Array.isArray(q.teams)) {
            userTeamInput.value = q.teams.map(Number);
        } else if (typeof q.teams === "string" && q.teams.length) {
            userTeamInput.value = q.teams.split(",").map(Number);
        } else {
            userTeamInput.value = [];
        }
    } else if (Array.isArray(q.teams)) {
        userTeamInput.value = q.teams.map(Number);
    } else if (typeof q.teams === "string" && q.teams.length) {
        userTeamInput.value = q.teams.split(",").map(Number);
    }

    if (userTeamInput.value.length) {
        await getFiltersData(userTeamInput.value);
    }

    if (["Customers", "Dashboard", "AccountDetails"].includes(route.name)) {
        const mandateStatusQueryValue = Array.isArray(q.mandateStatuses)
            ? q.mandateStatuses[0]
            : q.mandateStatuses;

        selectedMandateStatus.value = resource.value.mandateStatuses
            ?.find((status) => String(status.id) === String(mandateStatusQueryValue))?.id
            ?? mandateStatusQueryValue ?? "";
    }

    // Capture Outside Click Handlers mapping native API architectures
    document.addEventListener("mousedown", handleMouseDown);
    document.addEventListener("mouseup", handleMouseUp);
});

// ClickOutside Composition Emulation Functional Handlers
let isMouseDownInside = false;
const handleMouseDown = () => { isMouseDownInside = true; };
const handleMouseUp = (event) => {
    if (!isMouseDownInside) return;
    isMouseDownInside = false;

    const isClickInsideElement = (
        event.target === props.filterToggler ||
        event.target === searchFilter.value ||
        searchFilter.value?.contains(event.target) ||
        event.target.closest('.flatpickr-calendar')
    );

    props.toggleSearchFilter(isClickInsideElement);
};

onBeforeUnmount(() => {
    document.removeEventListener("mousedown", handleMouseDown);
    document.removeEventListener("mouseup", handleMouseUp);
});

// Reactive Watchers: Auto Adjust Intersecting Date Boundaries
watch(startDateFrom, (newDate) => {
    if (newDate > startDateTo.value || !startDateTo.value) startDateTo.value = newDate;
});
watch(startDateTo, (newDate) => {
    if (newDate < startDateFrom.value || !startDateFrom.value) startDateFrom.value = newDate;
});
watch(endDateFrom, (newDate) => {
    if (newDate > endDateTo.value || !endDateTo.value) endDateTo.value = newDate;
});
watch(endDateTo, (newDate) => {
    if (newDate < endDateFrom.value || !endDateFrom.value) endDateFrom.value = newDate;
});
watch(submitDateFrom, (newDate) => {
    if (newDate > submitDateTo.value || !submitDateTo.value) submitDateTo.value = newDate;
});
watch(submitDateTo, (newDate) => {
    if (newDate < submitDateFrom.value || !submitDateFrom.value) submitDateFrom.value = newDate;
});
watch(deadlineFrom, (newDate) => {
    if (newDate > deadlineTo.value || !deadlineTo.value) deadlineTo.value = newDate;
});
watch(deadlineTo, (newDate) => {
    if (newDate < deadlineFrom.value || !deadlineFrom.value) deadlineFrom.value = newDate;
});
watch(birthdayFrom, (newDate) => {
    if (newDate > birthdayTo.value || !birthdayTo.value) birthdayTo.value = newDate;
});
watch(birthdayTo, (newDate) => {
    if (newDate < birthdayFrom.value || !birthdayFrom.value) birthdayFrom.value = newDate;
});

// Backend Synchronization Methods
const getFiltersData = async (teamIds) => {
    userTeamInput.value = teamIds;
    moreFilters.value = false;
    loadingResources.value = true;

    if (Array.isArray(teamIds) && teamIds.length) {
        if (props.searchType === "customer") {
            await store.dispatch("getSearchCustomerForms", teamIds);
            resource.value = searchCustomerForms.value;
        } else if (props.searchType === "lead") {
            await store.dispatch("getSearchLeadForms", teamIds);
            resource.value = searchLeadForms.value;
        } else if (props.searchType === "potentialCustomer") {
            await store.dispatch("getSearchPotentialCustomerForms", teamIds);
            resource.value = searchPotentialCustomerForms.value;
        } else if (props.searchType === "policy") {
            await store.dispatch("getSearchPoliciesForms", teamIds);
            resource.value = searchPoliciesForms.value;
        } else if (props.searchType === "user") {
            selectedTeam.value = teamIds;
        }
    }
    loadingResources.value = false;
};

const search = async () => {
    isRequesting.value = true;
    loadingResources.value = true;
    const selectedTeams = userTeamInput.value?.length ? userTeamInput.value : selectedTeam.value || [];

    if (["Customers", "Dashboard", "AccountDetails"].includes(route.name)) {
        const query = {
            page: 1,
            search: searchKeywords.value || undefined,
            teams: selectedTeams.length ? selectedTeams : undefined,
            agents: agents.value.length ? agents.value.join(",") : undefined,
            companyTypes: companyTypes.value.length ? companyTypes.value.join(",") : undefined,
            companies: companies.value.length ? companies.value.join(",") : undefined,
            branchCategories: branchCategories.value.length ? branchCategories.value.join(",") : undefined,
            policyStatuses: policyStatuses.value.length ? policyStatuses.value.join(",") : undefined,
            mandateStatuses: normalizeMandateStatusList(selectedMandateStatus.value),
            has_terminations: terminationValue.value || undefined,
            payment_status: paymentStatus.value || undefined,
            birthday_from: birthdayFrom.value || undefined,
            birthday_to: birthdayTo.value || undefined,
            zip_from: zipFrom.value || undefined,
            zip_to: zipTo.value || undefined,
            startDateFrom: startDateFrom.value || undefined,
            startDateTo: startDateTo.value || undefined,
            endDateFrom: endDateFrom.value || undefined,
            endDateTo: endDateTo.value || undefined,
            submitDateFrom: submitDateFrom.value || undefined,
            submitDateTo: submitDateTo.value || undefined,
            ...(["Customers", "Dashboard", "AccountDetails"].includes(route.name) ? { pendency_number: pendencyNr.value || undefined } : {}),
        };

        if (route.name === "Customers") {
            router.replace({ query }).catch(() => { });
        } else {
            router.push({ path: "/customers", query }).catch(() => { });
        }
    } else if (route.name === "PotentialCustomers") {
        const query = {
            page: 1,
            teams: selectedTeams.length ? selectedTeams : undefined,
            search: searchKeywords.value || undefined,
            agents: agents.value.length ? agents.value.join(",") : undefined,
            companyTypes: companyTypes.value.length ? companyTypes.value.join(",") : undefined,
            branchCategories: branchCategories.value.length ? branchCategories.value.join(",") : undefined,
            priorities: priorities.value.length ? priorities.value.join(",") : undefined,
            birthday_from: birthdayFrom.value || undefined,
            birthday_to: birthdayTo.value || undefined,
            startDateFrom: startDateFrom.value || undefined,
            startDateTo: startDateTo.value || undefined,
            endDateFrom: endDateFrom.value || undefined,
            endDateTo: endDateTo.value || undefined,
            zip_from: zipFrom.value || undefined,
            zip_to: zipTo.value || undefined,
        };
        await router.replace({ name: "PotentialCustomers", query }).catch(() => { });
    } else if (route.name === "Policies") {
        const query = {
            page: 1,
            search: searchKeywords.value || undefined,
            teams: selectedTeams.length ? selectedTeams : undefined,
            agents: agents.value.length ? agents.value.join(",") : undefined,
            companies: companies.value.length ? companies.value.join(",") : undefined,
            branchCategories: branchCategories.value.length ? branchCategories.value.join(",") : undefined,
            policyStatuses: policyStatuses.value.length ? policyStatuses.value.join(",") : undefined,
            startDateFrom: startDateFrom.value || undefined,
            startDateTo: startDateTo.value || undefined,
            endDateFrom: endDateFrom.value || undefined,
            endDateTo: endDateTo.value || undefined,
            submitDateFrom: submitDateFrom.value || undefined,
            submitDateTo: submitDateTo.value || undefined,
        };
        await router.replace({ name: "Policies", query }).catch(() => { });
    } else if (route.name === "Users") {
        const normalizedStatus = normalizeUserStatus(selectedStatus.value);
        const query = {
            page: 1,
            search: searchKeywords.value || undefined,
            teams: selectedTeams.length ? selectedTeams : undefined,
            active_users: normalizedStatus !== null ? normalizedStatus : undefined,
        };
        await router.replace({ name: "Users", query }).catch(() => { });
    } else if (route.name === "Leads") {
        const query = {
            page: 1,
            search: searchKeywords.value || undefined,
            teams: selectedTeams.length ? selectedTeams : undefined,
            agents: agents.value.length ? agents.value.join(",") : undefined,
            lead_statuses: leadStatuses.value.length ? leadStatuses.value.join(",") : undefined,
            lead_categories: leadCategories.value.length ? leadCategories.value.join(",") : undefined,
            lead_referrals: leadReferrals.value.length ? leadReferrals.value.join(",") : undefined,
            deadline_from: deadlineFrom.value || undefined,
            deadline_to: deadlineTo.value || undefined,
            zip_from: zipFrom.value || undefined,
            zip_to: zipTo.value || undefined,
        };
        await router.replace({ name: "Leads", query }).catch(() => { });
    }
    props.toggleSearchFilter(false);
    loadingResources.value = false;
    isRequesting.value = false;
};

const exportCustomersTable = async () => {
    isRequesting.value = true;
    loadingResources.value = true;
    if (route.name === "Customers") {
        const selectedTeams = userTeamInput.value?.length ? userTeamInput.value : selectedTeam.value || [];
        await store.dispatch("searchCustomers", {
            search: searchKeywords.value,
            agents: agents.value,
            companyTypes: companyTypes.value,
            companies: companies.value,
            branchCategories: branchCategories.value,
            policyStatuses: policyStatuses.value,
            mandateStatuses: normalizeMandateStatusList(selectedMandateStatus.value) ?? "",
            birthday_from: birthdayFrom.value,
            birthday_to: birthdayTo.value,
            zip: zipFrom.value,
            has_terminations: terminationValue.value,
            startDateFrom: startDateFrom.value,
            startDateTo: startDateTo.value,
            endDateFrom: endDateFrom.value,
            endDateTo: endDateTo.value,
            submitDateFrom: submitDateFrom.value,
            submitDateTo: submitDateTo.value,
            payment_status: paymentStatus.value,
            teamId: selectedTeams[0] || null,
            export: true,
        });
    }
    loadingResources.value = false;
    isRequesting.value = false;
};

const exportPoliciesTable = async () => {
    isRequesting.value = true;
    loadingResources.value = true;
    const selectedTeams = userTeamInput.value?.length ? userTeamInput.value : selectedTeam.value || [];
    await store.dispatch("searchPolicies", {
        search: searchKeywords.value,
        agents: agents.value,
        companies: companies.value,
        branchCategories: branchCategories.value,
        policyStatuses: policyStatuses.value,
        startDateFrom: startDateFrom.value,
        startDateTo: startDateTo.value,
        endDateFrom: endDateFrom.value,
        endDateTo: endDateTo.value,
        submitDateFrom: submitDateFrom.value,
        submitDateTo: submitDateTo.value,
        teamId: selectedTeams[0] || null,
        export: true,
    });
    loadingResources.value = false;
    isRequesting.value = false;
};

const exportUsersTable = async () => {
    isRequesting.value = true;
    loadingResources.value = true;
    const selectedTeams = userTeamInput.value?.length ? userTeamInput.value : selectedTeam.value || [];
    const normalizedStatus = normalizeUserStatus(selectedStatus.value);
    await store.dispatch("searchUsers", {
        search: searchKeywords.value,
        teamId: selectedTeams[0] || null,
        active_users: normalizedStatus,
        isExport: true,
    });
    loadingResources.value = false;
    isRequesting.value = false;
};

const exportLeadsTable = async () => {
    isRequesting.value = true;
    loadingResources.value = true;
    const selectedTeams = userTeamInput.value?.length ? userTeamInput.value : selectedTeam.value || [];
    await store.dispatch("searchLeads", {
        search: searchKeywords.value,
        agents: agents.value,
        lead_statuses: leadStatuses.value,
        lead_categories: leadCategories.value,
        lead_referrals: leadReferrals.value,
        deadline_from: deadlineFrom.value,
        deadline_to: deadlineTo.value,
        zip_from: zipFrom.value,
        zip_to: zipTo.value,
        teamId: selectedTeams[0] || null,
        export: true,
    });
    loadingResources.value = false;
    isRequesting.value = false;
};
</script>

<style lang="scss" scoped>
.style-full {
    width: 100%;

    input,
    .input--default,
    .select--default {
        width: 100%;
    }
}

.label-block {
    display: block;
    margin-bottom: 10px;
}

.disabled-input2 {
    color: grey !important;
    font-family: var(--muli-text-semi-bold);
    background-color: var(--bg-1);
}

.payment-type::placeholder {
    color: var(--color-9) !important;
}

.custom-option {
    display: flex;
    align-items: center;
    gap: 1em;
    width: 100%;
}

.icon__payment--pending {
    margin-right: 4px !important;
    margin-left: 2px !important;
}

.custom-option-icon {
    transform: scale(0.7);
}

.slide-fade-in-enter-active {
    transition-duration: 0.4s;
    transition-timing-function: ease-in;
}

.slide-fade-in-leave-active {
    transition-duration: 0.4s;
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-fade-in-enter-to,
.slide-fade-in-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-fade-in-enter,
.slide-fade-in-leave-to {
    overflow: hidden;
    max-height: 0;
}

.form__field {
    margin-bottom: 0 !important;
}

.filter-birthday {
    width: 100%;

    :deep(.mx-input),
    :deep(input) {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
    }
}

.divider {
    width: 100%;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.line-divider {
    flex-grow: 1;
    height: 1px;
    background-color: #B9C2CD;
}

.text-divider {
    color: var(--text-5);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    font-size: 14px;
    cursor: pointer;

    img {
        width: 16px;
        height: 16px;
    }
}

.select-column {
    border: 1px solid transparent;
    background-color: var(--bg-1);
    box-shadow: 0px 5px 30px var(--shadow-4);
    color: var(--color-9) !important;
}

.date-label {
    color: var(--text-5);
    font-family: var(--muli-text-semi-bold);
    font-size: 14px;
    font-style: italic;
}

.search-filter {
    position: absolute;
    top: 100%;
    right: 0;
    background: var(--bg-1);
    width: 900px;
    padding: 60px;
    z-index: 2;
    box-shadow: 0px 5px 30px var(--shadow-4);
    border-radius: var(--radius-3);

    .search-export__button {
        box-shadow: none;
        width: 100%;
        background-color: #B9C2CD;
        height: 40px;
        display: flex;
        padding: 0 10px;
        font-size: 14px;
        margin: 0 !important;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        gap: 10px;
        font-family: var(--muli-text-semi-bold);
        color: #FFFFFF;
        border-radius: 10px;
        transition: 0.3s ease;

        &:hover {
            background: var(--text-5);
        }

        img {
            width: 20px;
            transition: 0.3s ease;
        }
    }

    &__title {
        color: var(--text-5);
        font-family: var(--muli-text-semi-bold);
        font-size: var(--medium);
        margin-bottom: 50px;
    }

    &__row,
    &__column--inputs {
        display: flex;
    }

    &__row {
        margin-bottom: 40px;
    }

    &__column {
        flex: 1;
        margin-right: 20px;

        &:last-child {
            margin-right: 0;
        }
    }

    &__button {
        margin: 60px auto 0 auto !important;
    }

    &__action-row {
        display: flex !important;
        justify-content: space-between;
        gap: 20px;
        margin-bottom: 0 !important;
        margin-top: 40px;
    }

    &__export-column {
        flex: 0 0 150px !important;
        margin-right: 0 !important;
    }

    &__filter-column {
        flex: 0 0 150px !important;
        margin-right: 0 !important;

        .search-filter__button {
            width: 100%;
            margin: 0 !important;
            height: 40px;
        }

        .button--loading {
            width: 100%;
            margin: 0 !important;
        }
    }

    &__column--half {
        flex: 0 0 50% !important;
        margin-right: 20px !important;
    }
}

.button--loading {
    width: 100% !important;
}

.report {
    &__choose-details {
        height: calc(100% - 220px - 40px);
        padding: 45px 15px 0 15px;

        &-datepickers,
        &-seperator {
            display: flex;
        }

        &-datepickers {
            background: var(--bg-3);
            border-radius: var(--radius-1);
            border: 1px solid transparent;

            &--error {
                background-color: var(--highlight-2);
                border-color: var(--border-9);
            }
        }

        &-month {
            flex: 1;
            margin-right: 15px;
        }

        &-year {
            width: 80px;
        }

        &-seperator {
            width: 0 !important;
            border-radius: 0;
            align-items: center;
            justify-content: center;
        }

        &-input {
            width: 55px;
            height: 28px;
            background: var(--bg-16);
            border-radius: var(--radius-1);
            text-align: center;
            color: var(--text-2);
        }
    }
}

[data-theme="dark"] .select--default {
    box-shadow: none;
    border: 1px solid #46505B;
}

.lead-double-column {
    display: flex;
    justify-content: space-between;

    input {
        width: 49% !important;
    }
}

@media (max-width: 680px) {

    .search-filter {
        width: 100%;
        max-width: 100%;
        padding: 24px;
        justify-content: space-between;
    }

    .search-filter__row {
        flex-direction: column;
        margin-bottom: 24px;
    }

    .search-filter__column,
    .search-filter__column--inputs,
    .search-filter__column--half {
        display: block;
        flex: 1 0 100%;
        max-width: 100%;
        width: 100%;
        margin-right: 0;
        margin-bottom: 16px;
    }

    .search-filter__column:last-child,
    .search-filter__column--inputs:last-child,
    .search-filter__column--half:last-child {
        margin-bottom: 0;
    }

    .search-filter__action-row {
        flex-direction: column;
        gap: 12px;
    }

    .search-filter__export-column,
    .search-filter__filter-column {
        flex: 1 0 100% !important;
        width: 100%;
        margin-right: 0 !important;
    }

    .search-filter__button {
        margin: 0 !important;
    }

    .label-block {
        margin-bottom: 8px;
    }
}

.deadline .report__choose-details-seperator {
    width: 0 !important;
}
</style>
